/**
 * Health Service
 *
 * The versions the platform reports about itself — what an About screen shows.
 */

import { TonnieClient } from '../client/base';

/** `GET /api/health/status` — the API's own version and build. */
export interface PlatformApiStatus {
  version: string;
  buildSha: string;
  environment: string;
  startedAt: string;
}

/** `GET /api/health/brain` — the brain's version report (a nested object, not flat). */
export interface BrainHealthReport {
  version: { version: string; buildSha?: string; openai_model?: string } | null;
}

export class HealthService {
  constructor(private client: TonnieClient) {}

  async getApiStatus(): Promise<PlatformApiStatus> {
    return this.client.get<PlatformApiStatus>('/api/health/status');
  }

  /** Answers 503 when the brain is unhealthy — then there is no version to show. */
  async getBrainHealth(): Promise<BrainHealthReport> {
    return this.client.get<BrainHealthReport>('/api/health/brain');
  }
}
